import React from 'react';

export const TriangleSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.1459 7.63939C18.5159 6.73839 17.5089 6.75539 16.9099 7.67739L6.08989 24.3234C5.49089 25.2454 5.89989 26.0004 6.99989 26.0004H29.9999C31.0999 26.0004 31.4829 25.2634 30.8539 24.3614L19.1459 7.63939Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.1459 7.63939C18.5159 6.73839 17.5089 6.75539 16.9099 7.67739L6.08989 24.3234C5.49089 25.2454 5.89989 26.0004 6.99989 26.0004H29.9999C31.0999 26.0004 31.4829 25.2634 30.8539 24.3614L19.1459 7.63939Z" fill="#E41D1D" />
    </svg>
  )
}